import { render } from "./clubs-table.template.html?vue&type=template&id=14668c64&scoped=true"
import script from "./ClubsTable.vue?vue&type=script&lang=ts"
export * from "./ClubsTable.vue?vue&type=script&lang=ts"

import "./ClubsTable.vue?vue&type=style&index=0&id=14668c64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14668c64"

export default script